module.exports = __webpack_public_path__ + "static/img/end.6fca7ddf.jpg";